import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import './ApplicationsPage.css';

interface SegmentGroup {
  id: string;
  translationKey: string;
  segments: string[];
}

const ApplicationsPage: React.FC = () => {
  usePageTitle('Applications - Who Uses JuryView');
  const { t } = useTranslation();

  const segmentGroups: SegmentGroup[] = [
    {
      id: 'trial-teams',
      translationKey: 'trialTeams',
      segments: ['trialConsultants', 'lawFirms'],
    },
    {
      id: 'enterprise',
      translationKey: 'enterprise',
      segments: ['insurance', 'corporate'],
    },
    {
      id: 'partners',
      translationKey: 'partners',
      segments: ['whiteLabel', 'integrationPartners'],
    },
  ];

  return (
    <div className="applications-page">
      <section className="applications-hero">
        <div className="container">
          <span className="section-label">{t('applications.label')}</span>
          <h1>{t('applications.title')}</h1>
          <p className="applications-subtitle">
            {t('applications.subtitle')}
          </p>
        </div>
      </section>

      <section className="applications-segments">
        <div className="container">
          {segmentGroups.map((group) => (
            <div key={group.id} className="segment-group">
              <h2 className="segment-group-label">
                {t(`applications.segmentGroups.${group.translationKey}.label`)}
              </h2>
              <div className="segments-grid">
                {group.segments.map((segmentKey) => (
                  <div key={segmentKey} className="segment-card">
                    <h3>{t(`applications.segments.${segmentKey}.title`)}</h3>
                    <p className="segment-description">
                      {t(`applications.segments.${segmentKey}.description`)}
                    </p>
                    <p className="segment-products">
                      {t(`applications.segments.${segmentKey}.products`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="applications-cta">
        <div className="container">
          <div className="cta-content">
            <h2>{t('common.requestDocumentation')}</h2>
            <p>
              {t('contact.subtitle')}
            </p>
            <Link to="/contact?type=docs" className="btn btn-primary">{t('common.requestDocumentation')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplicationsPage;
